export const menuTitle = { title: "PRODUCT STYLE", label: "Product Style" }
  